//  ======================== This is a custom Modal / POP UP Dialog component. This will use for anything ==========================
// this will contain a children component inside the modal

const CustomModal = (props) => {
    const { children, openPopup, setOpenPopup } = props;

    return (
        openPopup ?
            <div className="customModel-wrapper">
                <div className="customModel-close-wrapper" onClick={() => setOpenPopup(false)}></div>
                <div className="custom-model-child">
                    {children}
                </div>
            </div>
            : null
    )

}

export default CustomModal
